/* eslint-disable @typescript-eslint/no-empty-function */
import TextField from '@material-ui/core/TextField';
import React from 'react';
import InputMask from 'react-input-mask';

export interface MaskedInputProps {
  mask: string;
  maskChar?: string;
  value: string | number;
  disabled?: boolean;
  label: string;
  helperText: string;
  error: any;
  variant?: 'standard' | 'outlined' | 'filled';
  required?: boolean;
  InputProps?: any;
  id?: string;
  autoFocus?: boolean;
  onChange: (e: any) => void;
  onBlur: (e: any) => void;
}

const MaskedInput: React.FC<MaskedInputProps> = ({
  mask = '',
  maskChar,
  value = '',
  disabled = false,
  label = '',
  helperText = '',
  error,
  variant = 'outlined',
  required = false,
  InputProps,
  id,
  autoFocus = true,
  onChange = () => {},
  onBlur = () => {},
}) => (
  <InputMask
    data-testid={'autosky-maskedinput'}
    id={id}
    mask={mask}
    maskChar={maskChar}
    value={value}
    onChange={onChange}
    onBlur={onBlur}
    disabled={disabled}
  >
    {(inputProps: any) => (
      <TextField
        {...inputProps}
        label={label}
        variant={variant}
        helperText={helperText}
        error={error}
        onChange={onChange}
        disabled={disabled}
        required={required}
        fullWidth
        inputProps={{ style: { textAlign: 'center' } }}
        autoFocus={autoFocus}
        InputProps={InputProps}
      />
    )}
  </InputMask>
);

export default MaskedInput;
